module.exports = __webpack_public_path__ + "static/img/8.4e539d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/zh/8.png
// module id = KyxK
// module chunks = 0